import * as types from './types';

const initialState = {
  modalData: {
    open: false,
    variant: 'primary',
    title: '',
    body: '',
    itemData: {},
  },
  editableItem: {},
  categories: [],
  categoriesLoading: true,
  currentRestaurant: null,
  visibleLists: [],
  hasEnteredMenu: false,
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MODAL_DATA:
      return {
        ...state,
        modalData: {
          ...state.modalData,
          ...action.payload,
        },
      };
    case types.SET_CURRENT_RESTAURANT:
      return {
        ...state,
        currentRestaurant: action.payload,
      };
    case types.SET_EDITABLE_ITEM:
      return {
        ...state,
        editableItem: action.payload,
      };
    case types.SET_VISIBLE_LISTS:
      return {
        ...state,
        visibleLists: action.payload,
      };
    case types.ADD_VISIBLE_LIST:
      return {
        ...state,
        visibleLists: [...state.visibleLists, action.payload],
      };
    case types.REMOVE_VISIBLE_LIST:
      return {
        ...state,
        visibleLists: state.visibleLists.filter(id => id !== action.payload),
      };
    case types.RESET_VISIBLE_LISTS:
      return {
        ...state,
        visibleLists: [],
      };
    case types.SET_HAS_ENTERED_MENU:
      return {
        ...state,
        hasEnteredMenu: action.payload,
      };
    case types.GET_CATEGORIES_REQUEST:
      return {
        ...state,
        categoriesLoading: true,
      };
    case types.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        categoriesLoading: false,
      };
    case types.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        categoriesLoading: false,
      };
    default:
      return state;
  }
};

export default commonReducer;
